import React, { Component } from 'react';
import './Signup.css';
import { Link, Redirect } from 'react-router-dom'
import { GOOGLE_AUTH_URL, FACEBOOK_AUTH_URL, GITHUB_AUTH_URL } from '../../constants';
import { signup } from '../../util/APIUtils';
import fbLogo from '../../img/fb-logo.png';
import googleLogo from '../../img/google-logo.png';
import githubLogo from '../../img/github-logo.png';
import Alert from 'react-s-alert';

class Signup extends Component {
    render() {
        if(this.props.authenticated) {
            return <Redirect
                to={{
                pathname: "/",
                state: { from: this.props.location }
            }}/>;            
        }

        return (
            <div className="signup-container">
                <div className="signup-content">
                    <h1 className="signup-title">Start your free 15 Day trial with ChasinFins!  Cancel anytime.</h1>
                    {/* <SocialSignup /> */}
                    {/* <div className="or-separator">
                        <span className="or-text">OR</span>
                    </div> */}
                    <SignupForm {...this.props} />
                    <span className="login-link">Already have an account? <Link to="/login">Login!</Link></span>
                </div>
            </div>
        );
    }
}


class SocialSignup extends Component {
    render() {
        return (
            <div className="social-signup">
                <a className="btn btn-block social-btn google" href={GOOGLE_AUTH_URL}>
                    <img src={googleLogo} alt="Google" /> Sign up with Google</a>
                <a className="btn btn-block social-btn facebook" href={FACEBOOK_AUTH_URL}>
                    <img src={fbLogo} alt="Facebook" /> Sign up with Facebook</a>
                {/* <a className="btn btn-block social-btn github" href={GITHUB_AUTH_URL}>
                    <img src={githubLogo} alt="Github" /> Sign up with Github</a> */}
            </div>
        );
    }
}

class SignupForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            password: '',
            loginResponse: null,
            returnUrl: null,
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        // Capture return_url parameter from URL query string
        const urlParams = new URLSearchParams(window.location.search);
        const returnUrl = urlParams.get('return_url');
        if (returnUrl) {
            console.log("Captured return_url:", returnUrl);
            this.setState({ returnUrl: returnUrl });
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const inputName = target.name;        
        const inputValue = target.value;

        this.setState({
            [inputName] : inputValue
        });        
    }

    handleSubmit(event) {
        event.preventDefault();   

        const signUpRequest = Object.assign({}, this.state);

        signup(signUpRequest)
        .then(response => {
            Alert.success("You're successfully registered. Please login to continue!");
            this.setState = {loginResponse: response};

                this.props.history.push({
                    pathname: '/purchase',
                    state: { loginResponse: response, mobileCallbackURL: this.state.returnUrl},
                });
            // }
        }).catch(error => {
            Alert.error((error && error.message) || 'Oops! Something went wrong. Please try again!');            
        });
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit} className="signup-form">
                <div className="form-item">
                    <label htmlFor="name" className="sr-only">Full Name</label>
                    <input 
                        type="text" 
                        id="name"
                        name="name" 
                        className="form-control" 
                        placeholder="Full Name"
                        value={this.state.name} 
                        onChange={this.handleInputChange} 
                        autoComplete="name"
                        required
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="email" className="sr-only">Email Address</label>
                    <input 
                        type="email" 
                        id="email"
                        name="email" 
                        className="form-control" 
                        placeholder="Email Address"
                        value={this.state.email} 
                        onChange={this.handleInputChange}
                        autoComplete="email"
                        required
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="password" className="sr-only">Password</label>
                    <input 
                        type="password" 
                        id="password"
                        name="password" 
                        className="form-control" 
                        placeholder="Password"
                        value={this.state.password} 
                        onChange={this.handleInputChange}
                        autoComplete="new-password"
                        minLength="6"
                        required
                    />
                </div>
                <div className="form-item">
                    <button type="submit" className="btn btn-block btn-primary">
                        Sign Up for Free Trial
                    </button>
                </div>
            </form>                    

        );
    }
}

export default Signup